module.exports = __webpack_public_path__ + "img/9788936456542.cccd8d27.jpg";